import React from "react";
import BenefitsTwoImages from "./BenefitsTwoImages";

const BenefitsTwoImagesTop = (props) => <BenefitsTwoImages {...props} />;

export default BenefitsTwoImagesTop;
